<template>
  <div>
    <header>
      <HeaderWhite/>
    </header>
    <main>
      <Carousel :selectTagKey="projectKey"/>
      <ProjectContents :selectProjectDataList="selectProjectDataList"/>
    </main>
    <footer>
      <Footer/>
    </footer>
  </div>
</template>

<script>
import HeaderWhite from '../components/common/HeaderWhite.vue'
import Footer from '../components/common/Footer'
import Carousel from '../components/project/Carousel.vue'
import ProjectContents from '../components/project/ProjectContents.vue'
import ProjectData from "../../public/project_data.json"
export default {
  name: 'project',
  components: {
    HeaderWhite,
    Footer,
    Carousel,
    ProjectContents
  },
  props: {
    title:String,
    tagKey:String,
  },
  data() {
    return {
      // projectのjsonデータ
      ProjectData,
      // 引き渡すデータリスト
      selectProjectDataList: {},
      projectKey: this.tagKey,
    }
  },
  created: function(){
    this.projectTitle = this.$route.params['title'];
    for (var item in this.ProjectData) {
      if (this.ProjectData[item].title_key === this.projectTitle){
        this.selectProjectDataList = this.ProjectData[item];        
        // 直接URLが打ち込まれた場合
        if(!this.projectKey){
          this.projectKey = this.selectProjectDataList.title_key
        }
        break
      }
    }

  }
}
</script>
<style>
</style>